{
  "version": 1,
  "asset_id": "59d3448a-2d0c-4c34-af52-f03a9834b0c4",
  "project_id": "ffb64923-1b9a-4ca5-abb2-d5d5fcd875fe",
  "url": "/__l5e/assets-v1/59d3448a-2d0c-4c34-af52-f03a9834b0c4/seraphicsecurity-240.webp",
  "r2_key": "a/v1/ffb64923-1b9a-4ca5-abb2-d5d5fcd875fe/59d3448a-2d0c-4c34-af52-f03a9834b0c4/seraphicsecurity-240.webp",
  "original_filename": "seraphicsecurity-240.webp",
  "size": 6002,
  "content_type": "image/webp",
  "created_at": "2026-09-18T14:39:15Z"
}
